var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{staticClass:"banner",attrs:{"width":"md"}},[_c('HeaderSection',{attrs:{"header":_vm.$prismic.asHtml(_vm.slice.primary.h1),"teaser":_vm.$prismic.asText(_vm.slice.primary.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }